import React from 'react';
import { PhoneCountryCodeType } from '@bus/models';
import { Button } from '@vwfs-bronson/bronson-react';
import { t } from 'i18next';
import { createOptionsList } from '../../../services/common/miscUtils';
import { CorrespondenceMethodEnum, NoYesEnum } from '../../../types/forms';
import { PhoneNumberFormField } from '../../Fieldset/PhoneNumberFormField';
import { SelectFormField } from '../../Fieldset/SelectFormField';
import { TextInputFormField } from '../../Fieldset/TextInputFormField';
import { FormField } from '../..';
import { nonBreakingSpace } from '../../../utils/constants';

export const createFormInputs = (disableAllFormControls: boolean) => {
  return {
    tradingAs: () => (
      <TextInputFormField
        fieldName="tradingAs"
        isDisabled={disableAllFormControls}
        labelTranslationKey="tradingDetailsServicePlanBusinessForm:fields:tradingAs:label"
        placeholderTranslationKey="tradingDetailsServicePlanBusinessForm:fields:tradingAs:placeholder"
      />
    ),
    legalName: () => (
      <TextInputFormField
        fieldName="legalName"
        isDisabled={disableAllFormControls}
        labelTranslationKey="tradingDetailsServicePlanBusinessForm:fields:legalName:label"
        placeholderTranslationKey="tradingDetailsServicePlanBusinessForm:fields:legalName:placeholder"
      />
    ),
    vatLiable: () => (
      <SelectFormField
        fieldName="vatLiable"
        isDisabled={disableAllFormControls}
        labelTranslationKey="tradingDetailsServicePlanBusinessForm:fields:vatLiable:label"
        optionList={createOptionsList(NoYesEnum, 'tradingDetailsServicePlanBusinessForm', 'noYes', null)}
      />
    ),
    vatNumber: () => (
      <TextInputFormField
        fieldName="vatNumber"
        isDisabled={disableAllFormControls}
        labelTranslationKey="tradingDetailsServicePlanBusinessForm:fields:vatNumber:label"
        placeholderTranslationKey="tradingDetailsServicePlanBusinessForm:fields:vatNumber:placeholder"
      />
    ),
    croNumber: () => (
      <TextInputFormField
        fieldName="croNumber"
        isDisabled={disableAllFormControls}
        labelTranslationKey="tradingDetailsServicePlanBusinessForm:fields:croNumber:label"
        placeholderTranslationKey="tradingDetailsServicePlanBusinessForm:fields:croNumber:placeholder"
      />
    ),
    croNumberButton: (isDisabled: boolean) => (
      <FormField
        name="croNumberButton"
        labelText={nonBreakingSpace} // An empty string or simple space would cause a broken layout
        isDisabled={isDisabled}
        render={() => (
          // eslint-disable-next-line @typescript-eslint/no-empty-function
          <Button name="croNumberButton" type="button" onClick={() => {}} disabled={isDisabled} full>
            {t(`tradingDetailsServicePlanBusinessForm:fields:croNumber:label`)}
          </Button>
        )}
      />
    ),
    email: () => (
      <TextInputFormField
        fieldName="email"
        isDisabled={disableAllFormControls}
        labelTranslationKey="tradingDetailsServicePlanBusinessForm:fields:companyEmail:label"
        placeholderTranslationKey="tradingDetailsServicePlanBusinessForm:fields:companyEmail:placeholder"
        validateOnChange
      />
    ),
    mobileNumber: () => (
      <PhoneNumberFormField
        fieldName="mobileNumber"
        isDisabled={disableAllFormControls}
        labelTranslationKey="tradingDetailsServicePlanBusinessForm:fields:mobileNumber:label"
        placeholderTranslationKey="tradingDetailsServicePlanBusinessForm:fields:mobileNumber:placeholder"
        type="mobile"
      />
    ),
    countryCode: () => (
      <SelectFormField
        fieldName="countryCode"
        isDisabled={disableAllFormControls}
        labelTranslationKey="tradingDetailsServicePlanBusinessForm:fields:countryCode:label"
        optionList={createOptionsList(PhoneCountryCodeType, 'tradingDetailsServicePlanBusinessForm', 'countryCode')}
      />
    ),
    correspondenceMethod: () => (
      <SelectFormField
        fieldName="correspondenceMethod"
        isDisabled={disableAllFormControls}
        labelTranslationKey="tradingDetailsServicePlanBusinessForm:fields:correspondenceMethod:label"
        optionList={createOptionsList(
          CorrespondenceMethodEnum,
          'tradingDetailsServicePlanBusinessForm',
          'correspondenceMethod'
        )}
      />
    ),
  };
};
